import axios from "axios";
import config from "../Config.json";

const ChatWithLLM = async (data) => {
    try {
        // add auth token from local storage to the header
        
        const AuthToken = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = AuthToken;

        
       try {
        const response = await axios.post(`${config.API_URL}/app/assistant`, data,)
        return response
       } catch (error) {
        return []
       }
    } catch (error) {
        return error
    }
}

export default ChatWithLLM;